import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CampoAggiuntivo, CampoUtility } from "../models/campo-aggiuntivo";
import { DynamicCrudService, OggettoConfig } from "../_services/dynamic-crud.service";
import { environment } from 'src/environments/environment';
import { FileStoreService } from '../_services/file-store.service';
import { ApiPathsService } from 'src/app/api-paths.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { GlobalStoreService } from '../_services/global-store.service';
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {Permission} from "../../Login/_guards/Permission";

@Component({
    templateUrl: './dynamic-edit.component.html'
})
export class DynamicEditComponent implements OnInit {
  environment = environment;
  @Input() DropdownSources: any = {};
  @Input() IsModal: boolean = true;
  @Input() ExternalAdd: boolean = false;
  @Input() ExternalSave: boolean = false;
  @Input() HideButtons: boolean = false;
  @Input() FromLista: boolean = false;
  @Input() Item: any = {};
  @Input() CrudSettings: OggettoConfig | any;
  @Input() ConcatParamsEdit: any = {};
  loading: boolean = false;
  @Output() updated = new EventEmitter<any>();
  Stampe: any;
  Refreshing: boolean = false;
  ngbActiveModal: NgbActiveModal;
  bup: any = {};
  constructor(
      private injector: Injector,
      public campoUtility: CampoUtility,
      public crudService: DynamicCrudService,
      public api: ApiPathsService,
      private filestore: FileStoreService,
    private route: ActivatedRoute,
    private location: Location,
    private globalStore: GlobalStoreService,
      public authSvc: AuthenticationService,
      public permissions: Permission,
  ){
    if (true) {
      this.ngbActiveModal = <NgbActiveModal>this.injector.get(NgbActiveModal);
    }
  }

  ngOnInit(): void {
    if (!this.CrudSettings) // se è stato aperto in vista pagina
      this.route.params.subscribe(data => {
        var type = data['type'];
        this.Item = data['id'] ? { id: parseInt(data['id']) } : undefined;
        this.IsModal = false;
        this.CrudSettings = this.crudService.GetCrudSettings(type);
        console.log("CrudSettings: ", this.CrudSettings);
        console.log("type: ", type);
        this.Refresh();
      })
    else
      this.Refresh();
  }

  Refresh(){
    this.Refreshing = true;
    if(this.Item?.id && (this.CrudSettings.HasGet ?? true))
      this.crudService.GetItem(this.CrudSettings, {id: this.Item?.id}).subscribe(data=>{
        this.SetData(this.CrudSettings.GetResponseHasData ? data : {data: data})
      })
    else if (!(this.CrudSettings.HasGet ?? true) && this.CrudSettings.EditView == 'Page')
      this.globalStore.$data.subscribe(data => {
        this.SetData( { data: data ?? Object.assign({}, this.CrudSettings.AddDefaultObject ?? {}) })
      })
    else
      this.SetData({ data: this.Item ?? Object.assign({}, this.CrudSettings.AddDefaultObject ?? {}) })
  }

  SetData(data) {
    this.bup = Object.assign({}, data.data);
    console.log("Bup", this.bup)
    var oldItem = Object.assign({}, this.Item);

    this.Item = Object.assign(data.data, this.ConcatParamsEdit ?? {}, {activeTab: oldItem.activeTab});
    if(this.CrudSettings.Map)
      this.Item = this.CrudSettings.Map(this.Item, this,);
    this.Stampe = data?.stampe;
    this.crudService.InitObject(this.Item, this.CrudSettings);
    this.FormBuilder();
    if(this.Item?.id){
      this.filestore.SetListaFile(this.Item.files);
      this.filestore.SelectSection(this.CrudSettings.RestRoute);
    }
    this.route.queryParams
      .subscribe(params => {
          Object.getOwnPropertyNames(params)?.forEach(prop => {
            this.Item[prop] = params[prop];
            console.log('copy ' + params[prop] + ' to ' + 'this.selected.' + prop)
          })
        }
      );
    if(this.CrudSettings.asyncMap)
      this.CrudSettings.asyncMap(this.Item, this, (item)=>{
        this.Item = item;
    });
    setTimeout(() => {
      this.Refreshing = false;
    }, 300)
  }

  FormBuilder(){
    this.CrudSettings?.sezioni?.forEach(sezione=>{
      sezione.campi?.forEach(campo=>{
        this.SetCampoSource(this.Item, campo);
      })
    });

    this.CrudSettings?.campi?.forEach(campo=>{
        this.SetCampoSource(this.Item, campo);
    })

  }


  save(close?: boolean) {
    this.loading = true;
    if(!this.ExternalSave) {
      this.crudService.Save(this.Item, this.CrudSettings, close, this.ExternalAdd, (saved) => {
        console.info("Saved: ", {
          Response: saved,
          Item: this.Item,
          Settings: this.CrudSettings,
          close: close,
          ExternalAdd: this.ExternalAdd
        })
        this.saved(saved.Item, saved.close)
      }, this.bup)

    }
    else {
      this.Item = this.CrudSettings.OnSaveMap ? this.CrudSettings.OnSaveMap(this.Item, this.api, this.bup) : this.Item;
      this.saved(this.Item, close)
    }

  }

  saved(data, close?: boolean) {
    if (data?.id)
      this.Item.id = data?.id ?? this.Item.id;
    this.updated.emit(Object.assign({}, this.Item));
    this.Refresh();
    if (close)
      this.close();
    this.loading = false;
  }

  onFileChanged() {
    this.Refresh();
  }

  ChangeHandler(item: { OnChange: string; Event: any, CampoAggiuntivo?: CampoAggiuntivo }) {
    console.log("Changehandler: ", item);
    switch (item.OnChange ) {
      case 'OnValutazionePersonaChange':
        if (this.Item.persona_id && !this.Item.id)
        this.api.ClassicPost('/anagrafica/clienti/mansioni/list', {
          page: 0, size: 10, stati: ['IC'], persona_id: this.Item.persona_id
        }).subscribe((res: { data: any[]; total: number; }) => {
          const Abilita = res.data.reduce((acc, mansione) => {
            return acc.concat(mansione.mansioneObject?.abilitaObject || []);
          }, []);
          this.Item.valutazioni = Abilita.map((abilita) => { return { abilita: abilita.id, abilitaObject: abilita, voto: null, note: '' }; });

        })
        return;
      case 'Refresh':
        this.Refresh();
        break;
    }
  }

  getparam(oggetto, param){
    return oggetto ? oggetto[param]: null;
  }

  customButton(selected, button) {
    this.crudService.CustomButtonClick(this.Item, button, false, this.CrudSettings,(x)=>{this.updated.emit(x)}, (x)=>{this.saved(x, button.close);}, (x)=>{this.close();} );
  }

  FilterHandler($event: {OnFilter: string; Event: any}) {

  }

  SetCampoSource(item, campo){

  }

  HasSaveButton() {
    var setting: OggettoConfig = this.CrudSettings;
    return setting.campi?.some(campo => !this.campoUtility.Disable(campo, this.Item) && campo.inputType != 'Presenze') && !setting.NoSave && (!this.Item.id || !setting.NoSaveEdit) && (this.Item.id || !setting.NoSaveAdd);
  }

  close() {
    if(this.IsModal)
      this.ngbActiveModal.dismiss();
    else
      this.location.back();
  }

}
